import React from 'react';
import enums from 'utilities/enums';
import IconManager from '../../../../utilities/services/IconManager';
import ColoredText from '../components/ColoredText';

const { NOTIFICATION_TYPES } = enums;

const ICON_BASED_ON_TYPE = {
  [NOTIFICATION_TYPES.ENTITY_ASSIGNED]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.CASE_ASSIGNED]: IconManager.get(IconManager.names.CASE),
  [NOTIFICATION_TYPES.RCU_RECEIVED]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.ENTITY_CREATED]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.CASE_CREATED]: IconManager.get(IconManager.names.CASE),
  [NOTIFICATION_TYPES.ENTITY_ASSIGNED_NEW_ISSUE]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.CASE_ASSIGNED_OM_ISSUE]: IconManager.get(IconManager.names.CASE),
  [NOTIFICATION_TYPES.KYC_REFRESH_ARRIVED]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.MENTION_IN_COMMENT]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.ENTITY_DELETED]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.CASE_DELETED]: IconManager.get(IconManager.names.CASE),
  [NOTIFICATION_TYPES.OM_EXPIRED]: IconManager.get(IconManager.names.CASE),
  [NOTIFICATION_TYPES.NOTIFY]: IconManager.get(IconManager.names.EXCLAMATION_MARK_TRIANGLE),
  [NOTIFICATION_TYPES.REASSIGN]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.ENTITY_UPDATED]: IconManager.get(IconManager.names.NATURAL_PERSON),
  [NOTIFICATION_TYPES.CASE_UPDATED]: IconManager.get(IconManager.names.CASE),
  [NOTIFICATION_TYPES.OM_EXPIRING]: IconManager.get(IconManager.names.CASE),
};

const NOTIFICATION_STATUSES = {
  UNREAD: 0,
  UNREAD_MANUALLY: 1,
  READ: 2,
  ARCHIVE: 3,
  DELETE: 4,
};

const NOTIFICATION_STATUSES_TEXT = {
  [NOTIFICATION_STATUSES.UNREAD]: 'Unread',
  [NOTIFICATION_STATUSES.READ]: 'Read',
  [NOTIFICATION_STATUSES.ARCHIVE]: 'Archive',
};

const replacePlaceholders = (contentPlaceholder, values) => {
  const parts = contentPlaceholder.split(/(\{\{.*?\}\})/);

  return parts.map((part, index) => {
    if (part.startsWith('{{') && part.endsWith('}}')) {
      const key = part.replace(/\{\{|\}\}/g, '');
      const replacementText = key === 'you' ? 'You' : values[key];
      return <ColoredText key={index} text={replacementText} />;
    } else {
      // Render regular text parts
      return part;
    }
  });
};

const NOTIFICATION_DELETION_STATUSES = {
  NONE: 0,
  PENDING_APPROVAL: 1,
  DELETED: 2,
  REJECTED: 3,
};

const notificationUtils = {
  NOTIFICATION_TYPES,
  NOTIFICATION_STATUSES,
  NOTIFICATION_STATUSES_TEXT,
  ICON_BASED_ON_TYPE,
  replacePlaceholders,
  NOTIFICATION_DELETION_STATUSES,
};

export default notificationUtils;
